import countries from './country'
export default {
  countries: countries,
  drawer: true, 
  info_drawer: false,
  responsive: false,
  systemlogo: '../logo.png',
  game_setting:{},
  loginbg: '../bg.png',
  applogo: '../logo-sm.png',
  nopreview: '../img/nopreview.png',
  noimgholder: '../img/noimg-holder.jpg',
  imgholder: '../img/img-holder.jpg',
  is_logged: false,
  show_alert: false,
  action_alert: {
    show: false,
    text: '',
    color: "primary",
    type: 'error',
    icon:'',
    timeout: 3000
  },
  overlay: false,
  alert_color: "secondary",
  alert_text: "No message",
  allow_set_up: false,
  allow_stat_box: false,
  is_admin: false,
  roles:[],
  branches:[],
  franchise:{},
  franchiseelist:[],
  sys_vars:[],
  product_status: [],
  account_transactions: [],
  action_permissions: [
    {action: "add_product", description: "Add product"},
    {action: "add_product_item", description: "Add product_item"},
    {action: "add_purchase", description: "Add purchase"},
    {action: "add_sales", description: "Add sales"},
    {action: "add_sales_discount", description: "Add sales Discount"},
    {action: "accept_job", description: "Accept Job"},
    {action: "complete_job", description: "Set Status complete"},
  ],
  page_permissions: [
    {page: "Dashboard", description: "Dashboard"},
    {page: "Inventory", description: "Inventory Management"},
    {page: "Purchases", description: "Purchase Management"},
    {page: "Sales", description: "Sales Management"},
    {page: "Customers", description: "Customers Management"},
    {page: "Vendors", description: "Vendors Management"},
     {page: "Expenses", description: "Expenses Management"},
    {page: "User Management", description: "User Management"},
    {page: "My Profile", description: "My Profile"},
    {page: "Settings", description: "General Settings"},
    {page: "My Sales", description: "My Sales"},
    {page: "Job Board", description: "Job Board"},
     {page: "My Jobs", description: "Personnel Jobs"},
      {page: "Customer Ledger", description: "Customer Ledger mobile view"},
      {page: "Collectibles", description: "Collectibles mobile view"}
  ],
  admin_menus: [
    { title: 'Users Management', icon: 'mdi-account-cog', page:'/users', show: true},
     { title: 'Settings', icon: 'mdi-cogs', page:'/general-settings', show: true},
    
     { title: 'My Profile', icon: 'mdi-badge-account-horizontal', page:'/profile', show: true}
  ],
  invetory_menus: [
     { title: 'Products', icon: 'mdi-archive-search', page:'/inventory', show: true},
     { title: 'Purchases', icon: 'mdi-text-box-multiple-outline', page:'/purchases', show: true},
     { title: 'Sales', icon: 'mdi-network-pos', page:'/sales', show: true},
    //  { title: 'Vendors', icon: 'mdi-store', page:'/vendors'},
    //  { title: 'Customers', icon: 'mdi-account-multiple', page:'/customers'},
  ],
  account_menus: [
    { title: 'Customers', icon: 'mdi-account-multiple', page:'/customers', show: true},
    { title: 'Vendors', icon: 'mdi-store', page:'/vendors'},
      { title: 'Expenses', icon: 'mdi-cash-off', page:'/expenses', show: true},
       { title: 'Installments', icon: 'mdi-calendar-account-outline', page:'/installments', show: true},
  ],
  finance: [
    //{ title: 'Statements', icon: 'mdi-account-multiple', page:'/customers'},
    { title: 'Invoices & Payments', icon: 'mdi-store', page:'/vendors', show: true},
    { title: 'Payroll', icon: 'mdi-store', page:'/vendors'},
    { title: 'Taxes & Duties', icon: 'mdi-store', page:'/vendors', show: true},
    { title: 'Insights', icon: 'mdi-store', page:'/vendors', show: true},
  ],
  staff_menus: [
    { title: 'My Sales', icon: 'mdi-account-file-text', color: "success", page:'/my-sales', show: true},
     { title: 'Job Board', icon: 'mdi-human-male-board-poll', color: "info", page:'/job-board', show: true},
     { title: 'My Profile', icon: 'mdi-badge-account-horizontal', color: "secondary", page:'/profile', show: true},
     { title: 'My Jobs', icon: 'mdi-account-wrench', color: "secondary", page:'/my-jobs', show: true},
     { title: 'Products', icon: 'mdi-archive-search', color: "info", page:'/inventory', show: true},
     { title: 'Purchases', icon: 'mdi-text-box-multiple-outline', color: "info", page:'/purchases', show: true},
     { title: 'Sales', icon: 'mdi-network-pos', color: "info", page:'/sales', show: true},
    { title: 'Customers', icon: 'mdi-account-multiple', color: "info", page:'/customers', show: true},
    { title: 'Vendors', icon: 'mdi-store', color: "info", page:'/vendors', show: true},
    { title: 'Expenses', icon: 'mdi-cash-off', color: "info", page:'/expenses', show: true},
     { title: 'Collectibles', icon: 'mdi-account-details', color: "info", page:'/collectibles', show: true},
     { title: 'Customer Ledger', icon: 'mdi-account-details', color: "info", page:'/ledger-mobile', show: false}
  ],
  organization: [

    { title: 'Employees', icon: 'mdi-account-tie', page:'/users', show: true},
    { title: 'Users Roles', icon: 'mdi-account-cog', page:'/users', show: true},
  ],
  service: [
    { title: 'SMS & Email', icon: 'mdi-account-multiple', page:'/customers', show: true},
    { title: 'Biller', icon: 'mdi-store', page:'/vendors'},
    { title: 'TAX Filling', icon: 'mdi-store', page:'/vendors', show: true},
  ],
   report_menus: [
    { title: 'Sales Reports', icon: 'mdi-chart-bar', page:'/sales-report', show: true},
     { title: 'Cashier Sales', icon: 'mdi-cash-register', page:'/cashier-reports', show: true},
      { title: 'Service Personnel', icon: 'mdi-account-cog', page:'/service-personnel', show: true},
    { title: 'Expenses Reports', icon: 'mdi-file-chart-check-outline', page:'/expenses-reports', show: true},
    { title: 'Profit Reports', icon: 'mdi-finance', page:'/profits', show: true},
  ],
  partner_menus: [
    { title: 'Partners', icon: 'mdi-handshake-outline', page:'/partners', show: true},
    { title: 'Partner Reports', icon: 'mdi-format-list-text', page:'/partner-reports', show: true}
  ],
}
  